<script>
import Layout from "@layouts/form";
import ContratoDespesa from "@forms/ContratoDespesa";

export default {
  page: {
    title: "Detalhes | Contrato Despesa"
  },
  components: { Layout, ContratoDespesa },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Contrato Despesa",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Contrato Despesa",
          href: "/ContratoDespesa"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ContratoDespesa :editable="editable"></ContratoDespesa>
    </div>
  </Layout>
</template>
